"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONFIG_KEY_REDACT_LIST = exports.ConfigKeys = void 0;
const constants_1 = require("./constants");
const messages_1 = require("./messages");
// ConfigKeys contains the union of the config, parent, and query parameter keys
exports.ConfigKeys = Object.assign(Object.assign(Object.assign({}, constants_1.ConfigServiceDataKeys), messages_1.ParentDataKeys), constants_1.QueryParamKeys);
// List of PII related fields to be redacted from queryStrings in server logs
exports.CONFIG_KEY_REDACT_LIST = [
    exports.ConfigKeys.AddressOne,
    exports.ConfigKeys.AddressTwo,
    exports.ConfigKeys.City,
    exports.ConfigKeys.DateOfBirth,
    exports.ConfigKeys.Email,
    exports.ConfigKeys.FirstName,
    exports.ConfigKeys.LastName,
    exports.ConfigKeys.PrimaryPhone,
    exports.ConfigKeys.Referrer,
    exports.ConfigKeys.State,
    exports.ConfigKeys.Zipcode,
];
//# sourceMappingURL=others.js.map